<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="sidebar-header">
    <a [routerLink]="['/']" class="app-logo">
      <div class="app-logo-small h-2rem">
        <img
          [src]="
            'assets/images/brand/' +
            (layoutService.config().colorScheme === 'light' ? projectConstants.emblemLogoLight : projectConstants.emblemLogoDark)
          "
        />
      </div>
      <div class="app-logo-normal">
        <img
          class="h-3rem ml-3"
          [src]="'assets/images/brand/' + (isPremium ? projectConstants.emblemLogoPremium : projectConstants.emblemLogoStarter)"
        />
      </div>
    </a>
    <button class="layout-sidebar-anchor p-link z-2" type="button" (click)="anchor()"></button>
  </div>

  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
  </div>
</div>
